import { useFormContext } from 'react-hook-form';
import { FormEditorForm } from '../../../shared';
import { FfcChildProps, getFieldErrors } from '../shared';
import FieldTitle from './FieldTitle';
import FieldHelpText from './FieldHelpText';
import FieldDefaultContent from './FieldDefaultContent';
import RequiredSwitch from './RequiredSwitch';
import FieldConfigurationWrapper from './FieldConfigurationWrapper';

const DefaultContentFieldConfiguration = ({ fieldIndex }: FfcChildProps) => {
  const { control, formState } = useFormContext<FormEditorForm>();
  const { label: titleError, helptext: descriptionError } = getFieldErrors(formState.errors.fields, fieldIndex);

  return (
    <FieldConfigurationWrapper>
      <FieldTitle control={control} fieldIndex={fieldIndex} error={titleError} />
      <FieldHelpText control={control} fieldIndex={fieldIndex} error={descriptionError} />
      <FieldDefaultContent control={control} fieldIndex={fieldIndex} error={descriptionError} />
      <RequiredSwitch control={control} fieldIndex={fieldIndex} />
    </FieldConfigurationWrapper>
  );
};

export default DefaultContentFieldConfiguration;
